import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import axios from 'axios';
import { gsap } from "../../gsap/gsap.min.js";
import { ScrollTrigger } from "../../gsap/ScrollTrigger.min.js";

function AboutUs() {
	const [page, setPage] = useState(null);
	const [pageTitle, setTitle] = useState(null);
	const [pageDescription, setDescription] = useState(null);
	const [pageText, setPageText] = useState(null);
	const [pageMedia, setMedia] = useState(null);
	const [isAccordionOpen, setAccordionOpen] = useState(false);
	const pageUrl = process.env.REACT_APP_API_PAGE_URL;

	useEffect(() => {
		const fetchData = async () => {
			axios.get(`${pageUrl}1f9a2cc2-4e54-4ebe-8743-da43555306a8`) // about us page id
				.then(res => {
					const response = res.data;
					setPage(response);
					/*console.log("AboutUs", response);*/
				});
		};

		fetchData();
	}, [pageUrl]);

	useEffect(() => {
		if (page != null) {
			if (page.title != null) {
				setTitle(page.title);
			}
			if (page.description != null) {
				setDescription(page.description);
			}
			if (page.text != null) {
				setPageText(page.text);
			}
			if (page.media != null) {
				setMedia(page.media);
			}
		}
	}, [page]);

	useEffect(() => {
		const animatedEls = document.querySelectorAll('.fadeInUp-el');
		animatedEls.forEach((el) => {
			gsap.fromTo(el,
				{
					opacity: 0,
					y: 50,
				},
				{
					opacity: 1,
					y: 0,
					duration: 2,
					ease: "power2.out",
					scrollTrigger: {
						trigger: el,
						start: "top-=100px 80%",
						end: "bottom 20%",
						toggleActions: "play reverse play reverse",
						markers: false,
					},
				}
			);
		});
	}, [pageTitle]);


	const scrollToSection = (sectionId) => {
		const section = document.getElementById(sectionId);
		if (section) {
			setTimeout(() => {
				gsap.to(window, {
					duration: 1.5,
					scrollTo: {
						y: section.offsetTop - 100
					}
				});
			}, 100)
		}
	};

	const toggleAccordion = () => { 
		const accordion = document.getElementById('about-accordion');

		if (isAccordionOpen) {
			scrollToSection('about-us-section');
			gsap.to(accordion, {
				height: 0,
				opacity: 0,
				duration: 0.5,
				ease: 'power2.inOut', 
			});
			 
		} else {
			gsap.set(accordion, { height: 'auto' });

			requestAnimationFrame(() => {
				const height = accordion.offsetHeight;
				gsap.fromTo(accordion, {
					height: 0,
					opacity: 0,
				}, {
					height: height,
					opacity: 1,
					duration: 0.5,
					ease: 'power2.inOut',
				});
			});
		}

		setAccordionOpen(!isAccordionOpen);
	};


	return (
		<>
			{pageTitle != null && (
				<div className="bg-dark pt-4 pb-5" id="about-us-section">
					<div className='container-lg py-5'>
						<div className='row text-wrapper'>
							<div className="col-12">
								<h1 className="fs-2 text-uppercase fw-bold text-white fadeInUp-el">
									{pageTitle}
								</h1>
							</div>
							{pageDescription != null && (
								<div className="col-12 col-md-10 col-lg-8 ">
									<p className="mt-4 pt-3 serif text-white fs-4 fadeInUp-el d-block" dangerouslySetInnerHTML={{ __html: pageDescription }}></p>
								</div>
							)}
						</div>
						<div className='row about-us-wrapper mt-5'>
							<div className="col-12">
								{!isAccordionOpen && (
									<button
										id="open-about-accordion"
										className="btn btn-outline-light rounded-pill fs-8 fw-bold px-4 py-2 fadeInUp-el"
										onClick={toggleAccordion}
									>
										About
										{isAccordionOpen ? <Icon.ArrowUpShort className="ms-2" /> : <Icon.ArrowDownShort className="ms-2" />}
									</button>
								)}
							</div>
						</div>
					</div>
					{pageMedia != null && (
						<div className='container-lg' id="about-accordion" style={{ height: 0, overflow: 'hidden' }}>
							<div className='row about-us-wrapper mt-4 pb-5'>
								<div className="col-12 link-grid-wrapper">
									{pageMedia.map((media, index) => (
										<a key={index} href={media.description} target="_blank" className="link-grid-anchor hover-cursor d-block w-50">
											<img src={media.url} alt={media.title || pageTitle + ": immagine correlata"} className="link-grid-image object-fit-contain w-100 h-100" />
										</a>
									))}
								</div>
								{pageText != null && (
									<div className="col-12 col-md-10 col-lg-8 mt-5">
										<p className="mt-4 pt-3 serif text-white fs-4 d-block" dangerouslySetInnerHTML={{ __html: pageText }}></p>
									</div>
								)}
								<div className="col-12 d-flex align-items-center justify-content-center">
									 <button
										id="close-about-accordion"
										className="plus-custom-icon no-decoration text-white"
										style={{ pointerEvents: 'all', transform: 'rotate(45deg) translateX(11px)' }}
										onClick={(e) => {
											e.preventDefault();
											toggleAccordion();
										}}
									>
										<span className="d-block text-white hover-cursor">+</span>
									</button>
								</div>
							</div>

						</div>
					)}
				</div>
			)}
		</>
	);
}

export default AboutUs;
